import {
    Description,
    Span,
    Card,
    Top,
    Image,
    Body,
    CompanyName,
    Role,
    DateText,
} from './ExperienceCardStyledComponent';

const ExperienceCard = ({ experience }) => {
    const calculateTotalDate = (dateString) => {
        const [start, end] = dateString.split(' – ');
        const startDate = new Date(`${start} 1`);
        const endDate = end === 'Present' ? new Date() : new Date(`${end} 1`);
        const diffTime = Math.abs(endDate - startDate);
        const diffMonths = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30.44));
        return diffMonths;
    };

    const totalDate = calculateTotalDate(experience.date);
    const years = Math.floor(totalDate / 12);
    const months = totalDate % 12;

    const formatDateString = (years, months) => {
        if (years > 0) {
            return ` (${years} year${years > 1 ? 's' : ''}${months > 0 ? ` ${months} month${months > 1 ? 's' : ''}` : ''})`;
        } else if (months > 0) {
            return ` (${months} month${months > 1 ? 's' : ''})`;
        }
        return '';
    };

    return (
        <Card>
            <Top>
                <Image src={experience.img} />
                <Body>
                    <Role>{experience.role}</Role>
                    <CompanyName style={{ color: 'text_primary' }}>
                        <a
                            href={experience.companyLink}
                            target='_blank'
                            rel='noopener noreferrer'
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            {experience.companyName}
                        </a>
                    </CompanyName>
                    <DateText>
                        {experience.date}
                        {formatDateString(years, months)}
                    </DateText>
                </Body>
            </Top>
            <Description>
                {experience.desc.length > 0 ? (
                    <Span>
                        {experience.desc.map((description, index) => (
                            <li key={index} style={{ margin: '10px' }}>
                                - {description}
                            </li>
                        ))}
                    </Span>
                ) : (
                    <Span>{experience.desc}</Span>
                )}
            </Description>
        </Card>
    );
};

export default ExperienceCard;
